import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StatusSharedComponent } from './status.component';
import { TextButtonInternalSharedModule } from '..//text.button/text-button-internal.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        StatusSharedComponent
    ],
    imports: [
        CommonModule,
        TextButtonInternalSharedModule,
        IconSharedModule
    ],
    exports: [
        StatusSharedComponent
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class StatusSharedModule {}
